<template>

    <article class="carousel">

        <p class="title-baseSemibold">{{$t('global_did_you_know_title')}}</p>

        <div class="container">

                <div class="templates">

                    <div class="template template-forest" ref="tipsForest" v-show="showForest">
                        <p class="template-text template-text-1">{{$t('statistics_carbone_emissions_1')}}</p>
                        <p class="template-text template-text-2">{{$t('statistics_carbone_emissions_2')}}</p>
                        <img src="/img/stats/forest-1.svg" class="img-1">
                        <img src="/img/stats/forest-2.svg" class="img-2">
                        <img src="/img/stats/forest-3.svg" class="img-3">
                        <img src="/img/stats/forest-4.svg" class="img-4">
                        <div class="wave"></div>
                    </div>
                    <div class="template template-mailbox" ref="tipsMailbox" v-show="showMailbox">
                        <p class="template-text template-text-1">{{$t('statistics_email_sent_second_1')}}</p>
                        <p class="template-text template-text-2">{{$t('statistics_email_sent_second_2')}}</p>
                        <img src="/img/stats/spewing-mailbox.svg" class="img-1">
                    </div>
                    <div class="template template-earth" ref="tipsEarth" v-show="showEarth">
                        <p class="template-text template-text-1">{{$t('statistics_internet_emissions_1')}}</p>
                        <p class="template-text template-text-2">{{$t('statistics_internet_emissions_2')}}</p>
                        <img src="/img/stats/sad-earth.svg" class="img-1">
                    </div>
                    <div class="template template-plane" ref="tipsPlane" v-show="showPlane">
                        <p class="template-text template-text-1">{{$t('statistics_mailbox_flying_1')}}</p>
                        <p class="template-text template-text-2">{{$t('statistics_mailbox_flying_2')}}</p>
                        <img src="/img/stats/plane.svg" class="img-1">
                        <div class="wave"></div>
                    </div>
                </div>
                <div class="indicators">
                    <div class="point" :class="{'active-point': activePoint1}"></div>
                    <div class="point" :class="{'active-point': activePoint2}"></div>
                    <div class="point" :class="{'active-point': activePoint3}"></div>
                    <div class="point" :class="{'active-point': activePoint4}"></div>
                </div>
                <div class="round-white round-white-left" v-show="isDesktop" @click="swipeLeft">
                    <img src="/img/stats/arrow-left-black.svg" class="img__20">
                </div>
                <div class="round-white round-white-right" v-show="isDesktop" @click="swipeRight">
                    <img src="/img/stats/arrow-right-black.svg" class="img__20">
                </div>
            </div>



    </article>

</template>

<script>
import ENUM from '../../assets/ENUM'
import Markdown from '../../components/Markdown'

export default {

    name: 'stats-carousel',

    components: {
        Markdown
    },

    watch: {
        'tipsVisibility.forest' (value) {
            if(value && value > this.tipsVisibility.mailbox) {
                this.pointBestVisibility = ENUM.STATS.CARROUSEL.FOREST
            }
        },
        'tipsVisibility.mailbox' (value) {
            if(value && value > this.tipsVisibility.forest && value > this.tipsVisibility.earth) {
                this.pointBestVisibility = ENUM.STATS.CARROUSEL.MAILBOX
            }
        },
        'tipsVisibility.earth' (value) {
            if(value && value > this.tipsVisibility.mailbox && value > this.tipsVisibility.plane) {
                this.pointBestVisibility = ENUM.STATS.CARROUSEL.EARTH
            }
        },
        'tipsVisibility.plane' (value) {
            if(value && value > this.tipsVisibility.earth) {
                this.pointBestVisibility = ENUM.STATS.CARROUSEL.PLANE
            }
        }
    },

    computed: {
        showForest() {
            return !this.isDesktop || Math.abs(this.templateArrayIndex)%4 === 0
        },
        showMailbox() {
            return !this.isDesktop || Math.abs(this.templateArrayIndex)%4 === 1
        },
        showEarth() {
            return !this.isDesktop || Math.abs(this.templateArrayIndex)%4 === 2
        },
        showPlane() {
            return !this.isDesktop || Math.abs(this.templateArrayIndex)%4 === 3
        },
        activePoint1() {
            return this.isDesktop
                ? this.templateArrayIndex%4 === 0
                : this.pointBestVisibility === ENUM.STATS.CARROUSEL.FOREST
        },
        activePoint2() {
            return this.isDesktop
                ? this.templateArrayIndex%4 === 1
                : this.pointBestVisibility === ENUM.STATS.CARROUSEL.MAILBOX
        },
        activePoint3() {
            return this.isDesktop
                ? this.templateArrayIndex%4 === 2
                : this.pointBestVisibility === ENUM.STATS.CARROUSEL.EARTH
        },
        activePoint4() {
            return this.isDesktop
                ? this.templateArrayIndex%4 === 3
                : this.pointBestVisibility === ENUM.STATS.CARROUSEL.PLANE
        }
    },

    data() {
        return {
            templateArrayIndex: 40,
            pointBestVisibility: ENUM.STATS.CARROUSEL.FOREST,
            tipsVisibility: {
                forest: 0,
                mailbox: 0,
                earth: 0,
                plane: 0
            },
            tipsObersever: {
                observerForest: null,
                observerMailbox: null,
                observerEarth: null,
                observerPlane: null
            }
        }
    },

    mounted() {
        this.tipsObserver()
    },

    methods: {
        tipsObserver() {
            this.createOberserver('forest', 'tipsForest', 'observerForest')
            this.createOberserver('mailbox', 'tipsMailbox', 'observerMailbox')
            this.createOberserver('earth', 'tipsEarth', 'observerEarth')
            this.createOberserver('plane', 'tipsPlane', 'observerPlane')
        },

        createOberserver(visibilityVar, tipsRef, observerName) {
            const imageElement = this.$refs[tipsRef]
            this.tipsObersever[observerName] = new IntersectionObserver(
                (entries) => {
                    const entry = entries[0]
                    this.tipsVisibility[visibilityVar] = Math.round(entry.intersectionRatio * 100)
                },
                {
                    threshold: Array.from({ length: 101 }, (_, i) => i / 100), // De 0 à 100% de visibilité
                }
            )
            this.tipsObersever[observerName].observe(imageElement)
        },

        destroyObersever(observer) {
            if (this.tipsObersever[observer]) {
                this.tipsObersever[observer].disconnect()
            }
        },

        swipeLeft() {
            this.templateArrayIndex--
        },

        swipeRight() {
            this.templateArrayIndex++
        }

    },
    beforeDestroy() {
        this.destroyObersever('observerForest')
        this.destroyObersever('observerMailbox')
        this.destroyObersever('observerEarth')
        this.destroyObersever('observerPlane')
    }

}
</script>

<style lang="scss" scoped>

.carousel {
    display: flex;
    flex-direction: column;
    padding: 40px 16px;
    background-color: $timberwolf;
    text-align: start;
    @media screen and (min-width: $above-tablet-length) {
        padding: 26px 0 56px;
    }

    .container {
        margin-top: 24px;
        display: flex;
        position: relative;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .templates {
            width: 100vw;
            margin-top: 24px;
            padding: 0 16px;
            display: flex;
            flex-direction: row;
            overflow: scroll;
            @media screen and (min-width: $above-tablet-length) {
                max-width: 400px;
                padding: 0;
                margin: 0;
                position: relative;
                align-items: center;
            }

            .template {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                position: relative;
                min-width: 85vw;
                height: 282px;
                margin-right: 8px;
                border-radius: 24px;
                padding: 24px 16px;
                overflow: hidden;
                max-width: 400px;
                justify-content: flex-start;
                @media screen and (min-width: $above-tablet-length) {
                    min-width: 400px;
                    margin: 0;
                }

                .template-text {
                    display: flex;
                    text-align: center;
                    color: $midnight;
                }

                .template-text-1 {
                    font-size: 15px;
                    font-weight: 400;
                    &:lang(ar-sa) {
                        font-size: 17px;
                        font-weight: 600;
                    }
                }

                .template-text-2 {
                    font-size: 17px;
                    font-weight: 600;
                    &:lang(ar-sa) {
                        font-size: 15px;
                        font-weight: 400;
                    }
                }

                .wave {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-image: url("/img/stats/wave.svg");
                    background-repeat: no-repeat;
                    background-size: cover;
                    z-index: 1;
                }
            }

            .template-forest {
                background: linear-gradient(180deg, #C7E6CC 0%, #81BB8A 100%);

                .img-1 {
                    position: absolute;
                    bottom: 0;
                    z-index: 2;
                }
                .img-2 {
                    position: absolute;
                    top: 90px;
                    right: 0;
                    z-index: 2;
                }
                .img-3 {
                    position: absolute;
                    left: 0;
                    top: 134px;
                    z-index: 2;
                }
                .img-4 {
                    position: absolute;
                    right: 0;
                    bottom: 96px;
                    z-index: 2;
                }
            }

            .template-mailbox {
                background: linear-gradient(155deg, #95B2D6 0%, #5FC6EC 100%);
                .img-1 {
                    position: absolute;
                    bottom: 0;
                }
            }

            .template-earth {
                background: linear-gradient(180deg, #D8EBDE 0%, #BBEAC9 100%);
                .img-1 {
                    position: absolute;
                    bottom: 0;
                }
            }

            .template-plane {
                background: linear-gradient(180deg, #A4D1ED 0%, #5AB1E9 100%);
                .img-1 {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    z-index: 2;
                }
            }

            /* Hide scrollbar for Chrome, Safari and Opera */
            &::-webkit-scrollbar {
                display: none;
            }
            /* Hide scrollbar for IE, Edge and Firefox */
            -ms-overflow-style: none;  /* IE and Edge */
            scrollbar-width: none;  /* Firefox */
        }

        .indicators {
            margin-top: 24px;
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;

            .point {
                margin: 0 2px;
                height: 4px;
                width: 4px;
                border-radius: 4px;
                background: rgba(50, 163, 235, 0.48);

            }

            .active-point {
                width: 12px;
                height: 4px;
                border-radius: 4px;
                background: $aquamarine;
            }
        }

        .round-white {
            padding: 6px;
            border-radius: 30px;
            background-color: $white;
            border: 2px solid $platinum;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            > img {
                width: 20px;
                object-fit: contain;
            }
        }

        .round-white-left {
            position: absolute;
            left: -51px;
        }

        .round-white-right {
            position: absolute;
            right: -51px;
        }
    }
}

</style>
